import { createFileRoute } from '@tanstack/react-router'
import { ReporterPicker } from '@/features/view-as/ReporterPicker'
import { AdminGuard } from '@/components/admin-guard'
import { AdminSubNav } from '@/components/shell/AdminSubNav'

export const Route = createFileRoute('/admin/view-as')({
  component: () => (
    <AdminGuard>
      <AdminSubNav />
      <ReporterPicker />
    </AdminGuard>
  ),
})
